import { useEffect, useState, useRef } from "react";
import createGlobe from "cobe";
import "../styles/home.css";
import Footer from '../components/layout/footer';
import ContactSection from '../components/layout/ContactSection';
import Circular_info from '../components/layout/Circular_info';

export default function Home() {
  const [sections, setSections] = useState([]);
  const canvasRef = useRef();
  const [phi, setPhi] = useState(0);
  const [count, setCount] = useState(0);
  const target = 10500000000000;

  const [isVisible, setIsVisible] = useState(false);
  const statsRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const threatMarkers = [
    { location: [45.4215, -75.6972], label: "DISTRIBUTED_DOS_ATTACK" },
    { location: [34.0522, -118.2437], label: "ZERO_DAY_EXPLOIT" },
    { location: [25.7617, -80.1918], label: "RANSOMWARE_ENCRYPTION" },
    { location: [55.0000, -35.0000], label: "MAN_IN_THE_MIDDLE" },
    { location: [70.0000, -100.0000], label: "BRUTE_FORCE_ENTRY" },
    { location: [-23.5505, -46.6333], label: "SQL_INJECTION_QUERY" },
    { location: [-34.6037, -58.3816], label: "CROSS_SITE_SCRIPTING" },
    { location: [4.7110, -74.0721], label: "PHISHING_CAMPAIGN" },
    { location: [-12.0464, -77.0428], label: "MALWARE_INFILTRATION" },
    { location: [51.5074, -0.1278], label: "DIRECTORY_TRAVERSAL" },
    { location: [48.8566, 2.3522], label: "BUFFER_OVERFLOW" },
    { location: [52.5200, 13.4050], label: "DNS_SPOOFING_ATTACK" },
    { location: [60.1699, 24.9384], label: "SOCIAL_ENGINEERING" },
    { location: [41.9028, 12.4964], label: "SESSION_HIJACKING" },
    { location: [30.0444, 31.2357], label: "CREDENTIAL_STUFFING" },
    { location: [-1.2921, 36.8219], label: "API_RECONNAISSANCE" },
    { location: [6.5244, 3.3792], label: "ROOTKIT_INSTALLATION" },
    { location: [-26.2041, 28.0473], label: "BOTNET_RECRUITMENT" },
    { location: [14.7167, -17.4677], label: "CRYPTODRAINER_ATTACK" },
    { location: [25.2048, 55.2708], label: "DATA_EXFILTRATION" },
    { location: [35.6895, 139.6917], label: "SUPPLY_CHAIN_COMPROMISE" },
    { location: [31.2304, 121.4737], label: "SPEAR_PHISHING_URL" },
    { location: [1.3521, 103.8198], label: "ADVANCED_PERSISTENT_ATTACK" },
    { location: [39.9042, 116.4074], label: "REMOTE_CODE_EXECUTION" },
    { location: [19.0760, 72.8777], label: "PRIVILEGE_ESCALATION" },
    { location: [21.0285, 105.8542], label: "INSIDER_THREAT_ACTION" },
    { location: [-33.8688, 151.2093], label: "SATELLITE_LINK_JAMMING" },
    { location: [-37.8136, 144.9631], label: "RFID_SKIMMING_ATTACK" },
    { location: [-41.2865, 174.7762], label: "SUBNET_SPOOFING" },
    { location: [13.4443, 144.7937], label: "PACKET_SNIFFING_NODE" },
  ];

  const statsData = [
      { label: "Vulnerabilities in complex supply chain interdependencies", value: 26 },
      { label: "Increasing sophistication of cybercrime", value: 22 },
      { label: "Uncertainty arising from geopolitical tensions", value: 20 },
      { label: "Rapid adoption of emerging technologies", value: 12 },
      { label: "Cyber skills gap", value: 7 },
      { label: "Expanding regulatory requirements with insufficient harmonization", value: 6 },
      { label: "IT–OT convergence", value: 6 },
    ];

  useEffect(() => {
    fetch("/api/landing/")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setSections(data);
        else if (data?.results && Array.isArray(data.results)) setSections(data.results);
      })
      .catch(() => {});

    let currentPhi = 0;
    let width = 0;

    // This ensures the globe size matches the parent container size
    const onResize = () => {
      if (canvasRef.current) {
        width = canvasRef.current.offsetWidth;
      }
    };
    window.addEventListener("resize", onResize);
    onResize();

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: width * 2,
      height: width * 2,
      phi: 0,
      theta: 0.15,
      dark: 1,
      diffuse: 1.2,
      mapSamples: 16000,
      mapBrightness: 6,
      baseColor: [0.05, 0.15, 0.15],
      markerColor: [1, 0, 0],
      glowColor: [0.1, 0.4, 0.4],
      opacity: 0.8,
      markers: [],
      onRender: (state) => {
        state.phi = currentPhi;
        currentPhi += 0.0025;
        // Keep globe dimensions in sync during render
        state.width = width * 2;
        state.height = width * 2;
        setPhi(currentPhi);
      },
    });



    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);


    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || 
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || 
        (e.ctrlKey && e.keyCode === 85) 
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, { 
      threshold: 0.2 
    });
    if (statsRef.current) observer.observe(statsRef.current);
    
    return () => {
      globe.destroy();
      window.removeEventListener("resize", onResize);
      document.removeEventListener("contextmenu", handleContextMenu); 
      document.removeEventListener("keydown", handleKeyDown); 
    };
  }, []);

  useEffect(() => {
    let startTime;
    const duration = 2000; 

    const easeOutQuart = (x) => 1 - Math.pow(1 - x, 4);

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easedProgress = easeOutQuart(progress);
      
      setCount(Math.floor(easedProgress * target));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [target]);

  return (
    <div className="text-white selection:bg-cyan-500/30 overflow-x-hidden">
      <style>{`
        @keyframes threatPulse {
          0%, 100% { opacity: 0; transform: translate(-50%, -50%) scale(0.85); }
          20%, 80% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        }
        .animate-threat-visible { animation: threatPulse 6s infinite ease-in-out; }
      `}</style>

      <section className="relative flex items-center overflow-hidden py-10 lg:py-0">
        <div className="max-w-7xl mx-auto px-6 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-4 items-center">
          
          <div className="z-20 space-y-4 lg:-mt-20 lg:-ml-20 flex flex-col items-center lg:items-start text-center lg:text-left">
            <div className="relative">
              <div className="hidden lg:block absolute -left-4 top-0 h-full w-[2px] bg-gradient-to-b from-cyan-400 via-blue-500 to-transparent opacity-50" />
              <h1 className="text-4xl sm:text-6xl md:text-[5.5rem] font-black tracking-tighter leading-[0.85] lg:leading-[0.75] uppercase flex flex-col">
                <span className="text-white drop-shadow-sm"
                style={{ fontFamily: '"Times New Roman", Times, serif' }}
                >
                  SE
                  <span className="text-green-500/70">C</span>
                  UWALL
                </span>

                <span className="text-lg sm:text-xl md:text-4xl tracking-[0.2em] text-slate-500 mt-2 font-light">TECHNOLOGIES</span>
                <span className="text-lg sm:text-xl md:text-4xl tracking-[0.2em] text-slate-500 mt-2 font-light">LIMITED</span>
              </h1>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start items-center gap-3 md:gap-4 font-mono text-sm sm:text-lg md:text-[25px] tracking-[0.3em] lg:tracking-[0.5em] pt-2 border-t border-white/5 w-full">
              <span className="text-green-500/100">DECODE</span>
              <span className="w-1 h-1 bg-slate-800 rounded-full"></span>
              <span className="text-white">SECURE</span>
              <span className="w-1 h-1 bg-slate-800 rounded-full"></span>
              <span className="text-green-500/100">DEFEND</span>
            </div>

          </div>

          {/* Fixed Container: Uses aspect-square to maintain shape and prevents clipping */}
          <div className="relative flex justify-center items-center w-full max-w-[600px] aspect-square mx-auto lg:translate-x-20">
            <div className="relative w-full h-full">
              {threatMarkers
                .map((marker, i) => {
                  const lat = marker.location[0] * (Math.PI / 180);
                  const lng = marker.location[1] * (Math.PI / 180);
                  const x = Math.cos(lat) * Math.sin(lng + phi);
                  const y = Math.sin(lat);
                  const z = Math.cos(lat) * Math.cos(lng + phi);
                  return { ...marker, x, y, z, i };
                })
                .filter(m => m.z > 0)
                .map((marker) => (
                  <div
                    key={marker.i}
                    className="absolute pointer-events-none animate-threat-visible"
                    style={{
                      left: `${50 + marker.x * 40}%`,
                      top: `${50 - marker.y * 40}%`,
                      zIndex: 50,
                      opacity: marker.z,
                      animationDelay: `${marker.i * 0.2}s`,
                      transform: 'translate(-50%, -50%)',
                    }}
                  >
                    <div className="flex flex-col items-center">
                      <div className="px-1.5 md:px-2 py-0.5 bg-red-600/40 border border-red-400/50 backdrop-blur-md mb-1">
                        <span className="text-[6px] md:text-[8px] font-mono font-black text-white whitespace-nowrap tracking-tighter uppercase">
                          {marker.label}
                        </span>
                      </div>
                      <div className="w-1 md:w-1.5 h-1 md:h-1.5 bg-red-500 rounded-full shadow-[0_0_10px_#ff0000] border border-white/30"></div>
                    </div>
                  </div>
                ))}

              <canvas
                ref={canvasRef}
                style={{ 
                  width: '100%', 
                  height: '100%',
                  maxWidth: '100%',
                  aspectRatio: "1/1"
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-16 px-6 text-center">
        <div className="max-w-5xl mx-auto flex flex-col items-center">
          <h2 className="text-3xl sm:text-5xl md:text-[4rem] font-serif font-thin tracking-tight text-white/90 leading-none flex flex-wrap items-baseline justify-center">
            <span className="text-red-600/70 mr-1 font-light">$</span>
            <span className="tabular-nums break-all">
              {count.toLocaleString()}
            </span>
          </h2>
          <p className="mt-3 text-[10px] sm:text-xs md:text-sm text-slate-500 font-mono font-thin tracking-[0.3em] md:tracking-[0.2em] uppercase px-4"
          style={{ fontFamily: '"Times New Roman", Times, serif' }}
          >
            
            Total projected global financial loss from cyber attacks by 2025
          </p>
        </div>
      </section>


      {/* Updated Stats Section */}
      <section ref={statsRef} className="py-24 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-12 items-center relative z-10">
          
          {/* Left Side: Heading */}
          <div className="space-y-6 lg:text-right">
            <div className="italic uppercase leading-[0.85]">
              <p className="text-emerald-500 font-mono text-[16px] uppercase tracking-[0.2em] leading-relaxed">
                Despite rising investment, 
              </p>
              <h2 className="text-5xl md:text-4xl font-black tracking-tighter text-white">
                cybersecurity remains largely ineffective across organizations
              </h2>             
            </div>
            
            <div className="max-w-md lg:ml-auto border-l-2 lg:border-l-0 lg:border-r-2 border-blue-500/50 pl-6 lg:pl-0 lg:pr-6 py-2">
              <p 
                className="text-green-500 text-[16.5px] tracking-[0.1em] leading-relaxed  opacity-80"
                style={{ fontFamily: '"Times New Roman", Times, serif' }}
              >
                Often organizations lack the resources, tools, and expertise to defend against increasingly sophisticated cyber threats. SecuWall delivering enterprise-grade protection and expert guidance without the complexity.
              </p>
              {/* Source Link Section */}
              <div className="mt-3 flex lg:justify-end">
                <a 
                  href="https://reports.weforum.org/docs/WEF_Global_Cybersecurity_Outlook_2025.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-green-500 hover:text-green-400 text-[12px] tracking-[0.2em] italic transition-colors duration-300 flex items-center gap-2"
                  style={{ fontFamily: '"Times New Roman", Times, serif' }}
                >
                  Source 
                  <span className="text-[10px]">→</span>
                </a>
              </div>
            </div>
          </div>

          {/* Center Divider: State Line with "IN 2025" */}
          <div className="hidden lg:flex flex-col items-center justify-center h-full relative px-4 self-stretch">
            <div className="w-[1px] h-full bg-gradient-to-b from-transparent via-blue-500/50 to-transparent"></div>
            <div className="absolute bg-[#050505] py-4 transform rotate-180" style={{ writingMode: 'vertical-rl' }}>
              <span className="text-slate-500 font-mono text-[12px] tracking-[0.5em] uppercase whitespace-nowrap">
                IN 2025
              </span>
            </div>
            
          </div>

          {/* Right Side: Stats */}
          {/* Right Side: Stats */}
          <div className="space-y-4">
            {statsData.map((stat, i) => {
              const visualWidth = (stat.value / 30) * 100;

              return (
                <div key={i} className="space-y-2">
                  <p className="text-teal-600 text-[12px] md:text-[16.5px] leading-relaxed"
                     style={{ fontFamily: '"Times New Roman", Times, serif' }}>
                    {stat.label}
                  </p>
                  
                  <div className="relative h-6 w-full bg-slate-900/40 rounded-full border border-white/5 overflow-hidden p-[1px]">
                    <div 
                      className="h-full rounded-full bg-gradient-to-r from-blue-700 via-blue-500 to-cyan-400 flex items-center justify-end px-3 transition-all duration-[1500ms] ease-out shadow-[0_0_15px_rgba(6,182,212,0.3)]"
                      style={{ 
                        // Automatically shrinks to 0% when isVisible is false
                        width: isVisible ? `${visualWidth}%` : '0%' 
                      }}
                    >
                      <span className="text-white font-black text-[9px] tracking-tighter">
                        {stat.value}%
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </section>    






      {/* Modern Video Section: Mission Briefing */}
      <section className="py-12 relative overflow-hidden">
        {/* Background Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full blur-[120px] rounded-full pointer-events-none"></div>

        <div className="max-w-screen-2xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {/* Left Side: Content (Matching Image Style) */}
            <div className="lg:col-span-5 space-y-8 text-left">
              <div className="space-y-4">
                
                <h2 
                  className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-white"
                  style={{ fontFamily: '"Times New Roman", Times, serif' }}
                >
                  SecuWall provides the <span className="italic text-green-500">strongest</span> cyber defense to keep you and business secure
                </h2>
              </div>

              <div className="space-y-1">
                <div className="text-5xl md:text-7xl font-black tracking-tighter text-green-500/60 ">
                  24/7
                </div>
                <div className="text-green-500 font-mono text-sm tracking-widest uppercase">
                  MDR Support
                </div>
              </div>

              <button 
                onClick={() => setIsModalOpen(true)}
                className="group flex items-center gap-3 text-xs font-bold tracking-[0.2em] uppercase text-white/80 hover:text-green-500 transition-colors"
              >
                SecuWall's Story 
                <span className="transform group-hover:translate-x-2 transition-transform duration-300">→</span>
              </button>
            </div>

            {/* Right Side: Video Frame */}
            <div className="lg:col-span-7 relative group">
              <div className="relative aspect-[16/9] rounded-2xl overflow-hidden border border-white/10 bg-black shadow-2xl w-full">
                <iframe
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-700"
                  src="https://www.youtube.com/embed/1zq4A0n3Yck?autoplay=1&mute=1&loop=1&playlist=1zq4A0n3Yck&controls=0&showinfo=0&modestbranding=1"
                  title="Background Loop"
                  allow="autoplay"
                ></iframe>

                {/* Scaled Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <button 
                    onClick={() => setIsModalOpen(true)}
                    className="w-16 h-16 md:w-18 md:h-18 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-md border border-white/20 text-white transform transition-all duration-500 group-hover:scale-110 "
                  >
                    <div className="w-0 h-0 border-t-[12px] md:border-t-[18px] border-t-transparent border-l-[20px] md:border-l-[30px] border-l-white border-b-[12px] md:border-b-[18px] border-b-transparent ml-2"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Full Screen Modal Popup */}
        {isModalOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10 bg-black/95 backdrop-blur-xl animate-in fade-in duration-300">
            {/* Close Button Container */}
            <div className="absolute top-20 right-12 z-[115]">
              <button 
                onClick={() => setIsModalOpen(false)}
                className="group p-2 hover:opacity-50 transition-opacity"
                aria-label="Close modal"
              >
                {/* Cross button */}
                <div className="relative w-4 h-4">
                  <span className="absolute top-1/2 left-0 w-full h-[1px] bg-white rotate-45"></span>
                  <span className="absolute top-1/2 left-0 w-full h-[1px] bg-white -rotate-45"></span>
                </div>
              </button>
            </div>
            
            <div className="w-full max-w-6xl aspect-video rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(0,0,0,1)] border border-white/10 relative">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/1zq4A0n3Yck?autoplay=1&mute=0&rel=0"
                title="SecuWall Full Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </section>


      {/* Risk Transformation Section */}
      <section className="py-12 md:py-24 relative overflow-hidden text-white">
        <div className="max-w-[1400px] mx-auto px-1 md:px-12 relative z-10 ">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            
            {/* 1. Left Column: Text Content */}
            <div className="lg:col-span-4 text-left lg:text-right z-20">
              <div className="space-y-2">
                <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-tight">
                  Reducing Cyber Risk to<br />
                  <span className="text-green-600">What Truly Matters</span>
                </h2>
              </div>
              
              <p className="text-white text-lg leading-relaxed max-w-sm 
                            /* Left align on mobile (default), right align on desktop */
                            mr-auto lg:ml-auto lg:mr-0">
                We help organizations strengthen security in practical, measurable ways by improving visibility,
                preparedness, and response. By combining proven security technologies with risk-backed assurance,
                we work with our customers to close real gaps and build long-term cyber resilience.
              </p>
            </div>

            {/* 2. Middle Column: Process Diagram */}
            <div className="lg:col-span-8 flex items-center justify-between relative 
                            /* Change min-h-[500px] to a smaller value for mobile */
                            min-h-[300px] md:min-h-[500px] 
                            scale-[0.55] sm:scale-75 lg:scale-100 
                            origin-center lg:origin-right 
                            max-sm:-translate-x-2">
              
              {/* Vertical Text: TOTAL CYBER RISK */}
              <div className="flex flex-col items-center mr-4">
                <span className="text-[10px] font-mono tracking-[0.6em] uppercase text-orange-600/80 [writing-mode:vertical-lr] rotate-180">
                  TOTAL CYBER RISK
                </span>
              </div>

              {/* Orange Entry Lines */}
              <div className="flex-1 flex flex-col justify-between h-[250px] md:h-[350px] relative min-w-[80px] sm:min-w-[120px]">
                {/* The Static CSS Lines */}
                {[...Array(20)].map((_, i) => (
                  <div key={i} className="h-[1px] w-full bg-gradient-to-r from-orange-600/15 to-orange-600/60"></div>
                ))}

                {/* The Overlaid Dot Animation */}
                <svg 
                  className="absolute inset-0 w-full h-full pointer-events-none" 
                  preserveAspectRatio="none" 
                  viewBox="0 0 100 100"
                >
                  <defs>
                    <filter id="orangeGlow" x="-50%" y="-50%" width="200%" height="200%">
                      <feGaussianBlur stdDeviation="0.4" result="blur" />
                      <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                  </defs>

                  {[...Array(20)].map((_, i) => {
                    // Calculate yPos to match the "justify-between" distribution
                    const yPos = (i / 19) * 100;
                    const pathData = `M 0,${yPos} L 100,${yPos}`;
                    const duration = 2 + (i % 5) * 0.5; // Smooth, moderate speed
                    const delay = (i * 0.8) % 12;

                    return (
                      <circle key={i} r="0.6" fill="#fb923c" filter="url(#orangeGlow)" opacity="0">
                        <animateMotion
                          dur={`${duration}s`}
                          begin={`${delay}s`}
                          repeatCount="indefinite"
                          path={pathData}
                          calcMode="linear"
                        />
                        <animate
                          attributeName="opacity"
                          values="0;0;1;1;0;0"
                          keyTimes="0;0.1;0.2;0.8;0.9;1"
                          dur={`${duration}s`}
                          begin={`${delay}s`}
                          repeatCount="indefinite"
                        />
                      </circle>
                    );
                  })}
                </svg>
              </div>

              {/* Card 1: RISK MITIGATION */}
              <div className="relative z-20 w-46 border border-green-500 rounded-lg p-6 shadow-[0_0_30px_rgba(59,130,246,0.2)]">
                <h3 className="text-center text-[10px] tracking-[0.3em] uppercase text-green-500/90 mb-10">
                  RISK <br /> MITIGATION
                </h3>
                
                <div className="space-y-12">
                  <div className="flex flex-col items-center text-center group">
                    <div className="text-3xl text-green-500 mb-2">💠</div>
                    <span className="text-xs font-medium text-green-500/60 leading-tight">SOC <br/>Platform</span>
                  </div>
                  <div className="flex flex-col items-center text-center group">
                    <div className="text-3xl text-blue-400 mb-2">❄️</div>
                    <span className="text-xs font-medium text-green-500/60 leading-tight">Cloud Security</span>
                  </div>
                  <div className="flex flex-col items-center text-center group">
                    <div className="text-3xl text-blue-400 mb-2">🛡️</div>
                    <span className="text-xs font-medium text-green-500/60 leading-tight">Network Security</span>
                  </div>
                </div>
              </div>

              {/* Energy Bridge with Smooth, Non-Shaking Path */}
              <div className="
                relative 
                /* Responsive height: slightly shorter on mobile to match the orange lines */
                h-[300px] md:h-[480px] 
                /* Critical Fix: Force a width on mobile and prevent shrinking */
                w-[60px] sm:w-[80px] md:w-[100px] 
                flex-shrink-0 
                mx-[-1px] flex items-center justify-center
              ">
                <svg 
                  className="absolute inset-0 w-full h-full z-10" 
                  preserveAspectRatio="none"
                  viewBox="0 0 100 100" 
                >
                  <defs>
                    <linearGradient id="cyberLineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.3" />
                      <stop offset="50%" stopColor="#3b82f6" stopOpacity="0.6" />
                      <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.01" />
                    </linearGradient>

                    {/* FIXED FILTER: Lowered stdDeviation for a clean, non-blurry, steady glow */}
                    <filter id="dotGlow" x="-20%" y="-20%" width="140%" height="140%">
                      <feGaussianBlur stdDeviation="0.4" result="blur" />
                      <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                  </defs>
                  
                  {[...Array(17)].map((_, i) => {
                    const startY = (i - 8) * 4 + 50;
                    const targetCenter = 50;
                    const endY = targetCenter + (startY - targetCenter) * 0.35;

                    const pathData = `M 0,${startY} L 100,${endY}`;
                    const duration = 1.5 + (i % 3); 
                    const delay = (i * 0.5) % 10;

                    return (
                      <g key={i}>
                        <line
                          x1="0"
                          y1={startY}
                          x2="100"
                          y2={endY}
                          stroke="url(#cyberLineGradient)"
                          strokeWidth="0.5"
                          strokeOpacity="0.5"
                        />

                        <circle 
                          r="0.6" // Slightly smaller radius for sharper look
                          fill="#93c5fd" 
                          filter="url(#dotGlow)" 
                          opacity="0"
                        >
                          <animateMotion
                            dur={`${duration}s`}
                            begin={`${delay}s`}
                            repeatCount="indefinite"
                            path={pathData}
                            calcMode="linear"
                          />
                          <animate
                            attributeName="opacity"
                            values="0;0;1;1;0;0"
                            keyTimes="0;0.1;0.2;0.8;0.9;1"
                            dur={`${duration}s`}
                            begin={`${delay}s`}
                            repeatCount="indefinite"
                          />
                        </circle>
                      </g>
                    );
                  })}
                </svg>
              </div>

              {/* --- ANIMATED RISK TRANSFER CIRCLE --- */}
              <style jsx>{`
                @keyframes slow-spin {
                  from { transform: rotate(0deg); }
                  to { transform: rotate(360deg); }
                }
                @keyframes pulse-subtle {
                  0%, 100% { opacity: 0.3; transform: scale(1); }
                  50% { opacity: 0.6; transform: scale(1.05); }
                }
                .animate-slow-spin {
                  animation: slow-spin 240s linear infinite;
                }
                .animate-pulse-subtle {
                  animation: pulse-subtle 10s ease-in-out infinite;
                }
              `}</style>
              <div className="relative z-20 flex items-center justify-center flex-shrink-0
                              /* Scale the whole group for small screens */
                              scale-[0.80] sm:scale-90 md:scale-100 
                              origin-center">
                {/* 1. Custom Rotating Dotted Ring (SVG for perfect circular dots) */}
                <div className="absolute w-[130px] h-[130px] animate-slow-spin">
                  <svg className="w-full h-full" viewBox="0 0 100 100">
                    <circle
                      cx="50"
                      cy="50"
                      r="48"
                      fill="none"
                      stroke="rgba(39, 199, 79, 0.79)"
                      strokeWidth="2.5"
                      strokeDasharray="1.5 10" // Small dot (0.1) followed by a gap (6)
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                {/* 2. Secondary Faster Orbiting Dots (Adds depth) */}
                <div className="absolute w-[160px] h-[160px] animate-[slow-spin_120s_linear_infinite_reverse]">
                  <svg className="w-full h-full" viewBox="0 0 100 100">
                    <circle
                      cx="50"
                      cy="50"
                      r="48"
                      fill="none"
                      stroke="rgba(218, 147, 54, 0.79)"
                      strokeWidth="1.5"
                      strokeDasharray="0.9 10"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                {/* 2. Secondary Faster Orbiting Dots (Adds depth) */}
                <div className="absolute w-[100px] h-[100px] animate-[slow-spin_120s_linear_infinite_reverse]">
                  <svg className="w-full h-full" viewBox="0 0 100 100">
                    <circle
                      cx="50"
                      cy="50"
                      r="48"
                      fill="none"
                      stroke="rgba(218, 147, 54, 0.79)"
                      strokeWidth="2.5"
                      strokeDasharray="0.9 10"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                {/* 3. Pulsing Back Glow */}
                <div className="absolute w-[300px] h-[300px] bg-blue-600/10 rounded-full blur-3xl animate-pulse-subtle" />

                {/* 4. The Main Circular Card */}
                <div className="relative w-[150px] h-[150px]   rounded-full flex flex-col items-center justify-center p-8 shadow-[0_0_40px_rgba(59,130,246,0.2)] overflow-hidden">
                  
                  {/* Animated Scanning Light Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-blue-400/5 to-transparent -translate-x-full animate-[shimmer_5s_infinite] pointer-events-none" />
                  <div className="flex flex-col items-center text-center">
                    <span className="text-green-500 text-[15px] font-bold tracking-tighter uppercase leading-none">
                      SecuWall<br/>MDR
                    </span>
                  </div>                  

                </div>
              </div>

              {/* Final Converging Point: Multiple blue lines leading to text */}
              <div className="
                relative 
                /* Responsive height: Matches the smaller scale of the circle on mobile */
                h-[60px] md:h-[100px] 
                /* Fixed width on mobile ensures the lines don't disappear */
                w-[20px] md:w-[50px] 
                /* Prevents the parent flex from crushing the SVG to 0 width */
                flex-shrink-0 
                mx-[-1px] flex items-center justify-center
              ">
                <svg className="absolute inset-0 w-full h-full z-10" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="cyberendLineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#6097f0ff" stopOpacity="0.3" />
                      <stop offset="50%" stopColor="#6097f0ff" stopOpacity="0.2" />
                      <stop offset="100%" stopColor="#6097f0ff" stopOpacity="0.1" />
                    </linearGradient>
                  </defs>
                  
                  {[...Array(7)].map((_, i) => {
                    // startY: Vertical spacing for 7 lines. 
                    // i=3 is the center line at exactly 50% height.
                    const startY = (i - 3) * 6 + 50; 
                    
                    let endY;
                    if (i === 3) {
                      // The middle (4th) line stays perfectly straight
                      endY = 50.01; 
                    } else {
                      // INCREASED DEGREE: Multiplier set to 4.5 for a sharp pinch
                      // Top 3 slant down (+), Bottom 3 slant up (-)
                      const slantIntensity = (3 - i) * 3.5;
                      endY = startY + slantIntensity;
                    }
                    
                    return (
                      <line
                        key={i}
                        x1="0"
                        y1={`${startY}%`} 
                        x2="100%" 
                        y2={`${endY}%`} 
                        stroke="url(#cyberendLineGradient)"
                        strokeWidth="1.5" // Slightly thicker since there are fewer lines
                        strokeOpacity="0.6"
                      />
                    );
                  })}
                </svg>
              </div>

              {/* End Label */}
              <div className="pl-2 md:pl-4 flex-shrink-0">
                <h4 className="
                  /* text-xl for small phones, text-3xl for tablets/desktop */
                  text-xl md:text-3xl 
                  font-bold 
                  tracking-tighter 
                  /* Slightly more leading on mobile to prevent letter overlap */
                  leading-[0.85] md:leading-[0.8] 
                  text-blue-400/90 
                  italic 
                  uppercase
                ">
                  END<br/>CYBER<br/>RISK
                </h4>
              </div>

            </div>
          </div>
        </div>
      </section>
          
      <section id="process-contact">
        <Circular_info />
      </section>

      <section id="contact-us">
        <ContactSection />
      </section>

      




      <div className="relative z-10 space-y-0">
        {sections.map((sec) => (
          <section key={sec.id} className="py-12 md:py-24 border-t border-white/5 backdrop-blur-sm px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-xl md:text-3xl font-bold uppercase tracking-widest text-white">{sec.heading}</h2>
              <div className="h-0.5 w-12 bg-cyan-500 mx-auto mt-4 mb-6"></div>
              <p className="text-slate-400 font-mono text-xs md:text-sm leading-relaxed md:leading-loose max-w-2xl mx-auto">{sec.subheading}</p>
            </div>
          </section>
        ))}
      </div>
      <Footer />
    </div>
  );
}